import { render } from "./NotificationList.vue?vue&type=template&id=87ba9656"
import script from "./NotificationList.vue?vue&type=script&lang=js"
export * from "./NotificationList.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=87ba9656&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__